export default "__VITE_ASSET__Cfqz1ZHD__"